import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      trackers: {
        header: 'HEADER',
        button_add_tracker: 'BUTTON_ADD',
        available_tracker: 'AVAILABLE_TRACKER',
        deals_button: 'DEALS_BUTTON',
        modal_window: {
          create: {
            title: 'MODAL_CREATE_TITLE',
            description: 'MODAL_CREATE_DESCRIPTION',
            ok: 'MODAL_CREATE_OK',
            cancel: 'MODAL_CREATE_CANCEL',
          },
          edit: {
            title: 'MODAL_EDIT_TITLE',
            description: 'MODAL_EDIT_DESCRIPTION',
            button_save: 'MODAL_EDIT_SAVE',
            button_cancel: 'MODAL_EDIT_CANCEL',
          },
        },
        condition: {
          header: 'CONDITION_HEADER',
          condition_is_absent: 'CONDITION_IS_ABSENT',
          back: 'CONDITION_BACK',
        },
      },
    },
  }));
}
